import actionTypes from './actionTypes'

const initialState = {
  bread: {
    keys: ['881050000000', '881050030000'],
    name: '首页',
    path: '/home',
    secondly: {title: '促销折扣', path: '/auth'},
    thirdly: {
      path: '/agency',
      title: '新建活动'
    }
  }
}
// initialState.bread = JSON.parse(sessionStorage.bread)

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATEBREAD:
      const bread = {bread: state.bread, ...action.payload}
      sessionStorage.bread = JSON.stringify(bread)
      return {...state, ...action.payload}
    default:
      return state
  }
}

export default reducer
